import { FC } from 'react';

// hooks
import useWillMount from 'hooks/useWillMount';

interface Props {
  onResize: () => void;
}

const WindowSizeObserver: FC<Props> = ({ onResize }) => {
  useWillMount(() => {
    // @ts-ignore
    const ResizeObserver = window.ResizeObserver as any;

    if (ResizeObserver) {
      const observer = new ResizeObserver(onResize);
      observer.observe(document.body);

      return () => {
        observer.unobserve(document.body);
      };
    }
  });

  return null;
};

export default WindowSizeObserver;
